/**
 * EnvBanner — Banner persistente que indica si estamos en un ambiente
 * que no es producción (QA, STAGING, DEMO, DEV). Se renderiza en la parte
 * superior del AppLayout y del PortalLayout cuando ENV_LABEL no está vacío.
 *
 * Adicionalmente, ajusta el document.title para distinguir pestañas.
 */
import { useEffect } from 'react'
import { AlertTriangle } from 'lucide-react'
import { useEnvInfo } from '@/hooks/useEnvInfo'

export function EnvBanner() {
  const { data } = useEnvInfo()
  const label = data?.env_label ?? ''

  useEffect(() => {
    if (!label) return
    const original = document.title
    document.title = `${label} · ${original}`
    return () => { document.title = original }
  }, [label])

  if (!label) return null

  return (
    <div className="w-full bg-warning-surface-strong border-b border-warning-border-strong text-warning-content-strong text-xs font-medium px-4 py-1.5 flex items-center justify-center gap-2">
      <AlertTriangle size={13} className="shrink-0" aria-hidden="true" />
      <span>
        Ambiente <strong>{label}</strong> — Datos de prueba. Documentos y notificaciones generados aquí <strong>no tienen validez legal</strong>.
      </span>
    </div>
  )
}
